import axios from "axios";
import { authorization } from "./SharedFunctions";

const loginApi = (data) => {
    return axios.post('/login', data);
}

const registerApi = (data) => {
    return axios.post('/register', data);
}

const logoutApi = (token) => {
    return axios.post('/logout', {}, authorization(token));
}

const logoutAllApi = (token) => {
    return axios.post('/logout_all', {}, authorization(token));
}

const disRememberApi = (data) => {
    return axios.post('/disremember', data)
}

const disRememberResetApi = (data) => {
    return axios.post('/disremember_reset', data)
}


export { loginApi, registerApi, logoutApi, logoutAllApi, disRememberApi, disRememberResetApi };